const getters = {
    store_id: (state) => state.store_id,
    store_name: (state) => state.store_name,
    industry_id: (state) => state.industry_id,
    seat_num: (state) => state.seat_num,
    date_from: (state) => state.date_from,
    date_to: (state) => state.date_to,
    saveStatus: (state) => state.saveStatus,
    changeStatus: (state) => state.changeStatus,
    isComparison: (state) => state.isComparison
};

export default getters;